export default "__VITE_ASSET__CnPvJ1AG__"